import { AlertProps } from '@mui/material';

import { StyledAlert } from '@/shared/ui/Alert/styles';
import { SvgIcon } from '@/shared/ui/SvgIcon';

export type TAlertProps = AlertProps;

const renderIconBySeverity = (severity: TAlertProps['severity']) => {
  switch (severity) {
    case 'error':
      return undefined;
    case 'warning':
      return undefined;
    case 'info':
      return <SvgIcon name="warning" fontSize="small" />;
    default:
      return undefined;
  }
};

export const Alert = ({ severity = 'success', ...otherProps }: TAlertProps) => {
  return (
    <StyledAlert
      severity={severity}
      icon={renderIconBySeverity(severity)}
      {...otherProps}
    />
  );
};
